import { Inline } from '@etg/wings';
import { css } from '@eti/styles';
import { Icon, ScreenReaderPrice } from '@eti/components';

const QuickSortPriceAndTimeStyles = css`
  font-weight: 500;

  span {
    color: #737373;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
interface QuickSortPriceAndTimeProps {
  formattedPrice: string;
  time?: string;
}
const QuickSortPriceAndTime = ({ formattedPrice, time }: QuickSortPriceAndTimeProps) => {
  return (
    <Inline alignY="center" className={QuickSortPriceAndTimeStyles} spacing={4}>
      <span aria-hidden className="price">
        {formattedPrice}
      </span>
      <ScreenReaderPrice price={formattedPrice} />
      {time && (
        <Inline alignY="center" noWrap spacing={4}>
          <Icon color="#737373" id="circle" size="3px" />
          <span className="time">{time}</span>
        </Inline>
      )}
    </Inline>
  );
};

export default QuickSortPriceAndTime;
